module.exports = __webpack_public_path__ + "static/media/ic_exclusive_preview.f3522759.jpg";